import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TABS, TransitionState } from "./constants";

export type State = {
  tabId: TABS;
  isOpen: boolean;
  transitionState: TransitionState;
};

export const initialState: State = {
  isOpen: false,
  tabId: TABS.CHAT,
  transitionState: TransitionState.ENDED,
};

const rightPanelSlice = createSlice({
  initialState,
  name: "rightPanel",
  reducers: {
    setPanelState: (
      state,
      action: PayloadAction<{ isOpen: boolean; tabId: TABS }>,
    ) => ({
      ...state,
      isOpen: action.payload.isOpen,
      tabId: action.payload.tabId,
    }),
    setTransitionState: (state, action: PayloadAction<TransitionState>) => ({
      ...state,
      transitionState: action.payload,
    }),
  },
});

export const { setPanelState, setTransitionState } = rightPanelSlice.actions;

export default rightPanelSlice.reducer;
